import {ComponentProps} from "react"
import {IAvisVerifiesResponse} from "@/app/endpoints/reviewEndpoint"
import AppIcon from "@/app/components/atomic/AppIcon"

type IconSize = ComponentProps<typeof AppIcon>["size"]

function StarIcon({filled, size}: { filled: boolean; size: IconSize }) {
    return (
        <span aria-hidden="true">
            <AppIcon
                iconClassName="fa-star"
                size={size}
                type={filled ? "solid" : "regular"}
                style={{color: filled ? "#E8C800" : "#d9d9d9"}}
            />
        </span>
    )
}

export function Stars({rating, size = "xs"}: { rating: number; size?: IconSize }) {
    return (
        <div className="flex gap-0.5" role="img" aria-label={`Note : ${rating} sur 5`}>
            {[1, 2, 3, 4, 5].map((star) => (
                <StarIcon key={star} filled={star <= rating} size={size}/>
            ))}
        </div>
    )
}

function formatDate(reviewDate: string): string {
    const [date] = reviewDate.split(" ")
    const [year, month, day] = date.split("-")
    return [day, month, year.slice(-2)].join("/")
}

interface Props {
    review: IAvisVerifiesResponse
    cardClassName?: string
}

export default function ReviewCard({review, cardClassName = "bg-neutral"}: Props) {
    return (
        <div className={`w-full rounded-2xl p-4 flex flex-col gap-4 min-h-[180px] ${cardClassName}`}>
            <div className="flex items-center gap-3">
                <div
                    className="rounded-full w-10 h-10 bg-pastel-blue flex items-center justify-center font-semibold text-lg text-white">
                    {review.firstname[0]}
                </div>
                <div className="flex flex-col">
                    <span className="font-semibold">{review.firstname} {review.lastname}.</span>
                    <Stars rating={review.rate}/>
                </div>
                <span className="ml-auto text-xs text-rm-gray">le {formatDate(review.review_date)}</span>
            </div>
            <p className="text-sm leading-relaxed italic">&quot;{review.review}&quot;</p>
        </div>
    )
}
